import { SupportTicketCreate } from '../request-models/support-ticket-create.model';
import { SupportTicketListQuery } from '../request-models/support-ticket-list-query.model';
import { QueryParams } from '../../abstract/query-params';
import { omitUndefined } from './wire-value-utils';

/** The create body with only the fields that are set (`organizationId` is required by the hub). */
export function toSupportTicketCreateRequest(input: SupportTicketCreate): SupportTicketCreate {
  return omitUndefined<SupportTicketCreate>({
    organizationId: input.organizationId,
    subject: input.subject,
    description: input.description,
    category: input.category,
    droneId: input.droneId,
  });
}

/** List query params; unset filters are dropped by the base. */
export function toSupportTicketListQuery(query: SupportTicketListQuery = {}): QueryParams {
  return {
    status: query.status,
    priority: query.priority,
    category: query.category,
    droneId: query.droneId,
    search: query.search || undefined,
    page: query.page,
    limit: query.limit,
  };
}
